/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import FacetTypeEnabled from './FacetTypeEnabled';
import UsageType from './UsageType';
import PropertySetter from './PropertySetter';
import RegularAggregateType from './RegularAggregateType';
import MoserObjectUtils from './MoserObjectUtils';
import ItemType from './ItemType';
import InstanceType from './InstanceType';
import QsClassifierType from './QsClassifierType';
import GenerateSQL from './GenerateSQL';
import SelectListControlType from './SelectListControlType';
import QuerySubjectUtils from './QuerySubjectUtils';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/FacetTypeEnabled (static) // FacetTypeEnabled
//@import com/ibm/bi/platform/moser/common/generated/metadata/UsageType (static) // UsageType
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (static) // set
//@import com/ibm/bi/platform/moser/common/generated/metadata/RegularAggregateType (static) // RegularAggregateType
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (static) // getList, sortByLabel
//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (static) // InstanceType
//@import com/ibm/bi/platform/moser/common/generated/metadata/QsClassifierType (static) // QsClassifierType
//@import com/ibm/bi/platform/moser/common/generated/metadata/GenerateSQL (static) // GenerateSQL
//@import com/ibm/bi/platform/moser/common/generated/metadata/SelectListControlType (static) // SelectListControlType
//@import com/ibm/bi/platform/moser/core/module/util/QuerySubjectUtils (runtime) // getParentQuerySubject

/**
 * @author  AlanTran
 */
export default class MetricCommonUtils extends BaseMoserObject{

	static setCommonQueryItemProp(qi, role, idForExpr, sentimentType, objectFactory) {
		var facetType = objectFactory.createFacetType();
		facetType.setEnabled(FacetTypeEnabled.AUTOMATIC);
		qi.setFacetDefinition(facetType);
		qi.setMetricRole(role);
		qi.setExpression(idForExpr);
		qi.setMetricSentiment(sentimentType);
	}

	/**
	 * Creates a new clone of the item ref, generates a new id, clear and reassign child items Clears the splitDefinition, add the ref of the original qs from the data module Adds the new qi to its relatedRef clone if needed
	 * @param {IdGenerator} idGenerator   an idGenerator
	 * @param {ObjectType} ref           the hierarchy item ref
	 * @param {MetricRoleType} role          the hierarchy item metricRoleType
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	static createMetricQueryItem(idGenerator, ref, role, sentimentType, objectFactory) {
		var qi;
		if ("QueryItem" == ref.getObjectType()) {
			qi = ref.clone();
			MetricCommonUtils.setCommonQueryItemProp(qi, role, ref.getIdForExpression(), sentimentType, objectFactory);
			idGenerator.generateId(qi);
			qi.setEditMode(null);
			qi.setSourceCategory(null);
			qi.setTransientSource(null);
			if (UsageType.ATTRIBUTE == qi.getUsage()) {
				PropertySetter.set(qi, 194, RegularAggregateType.NONE, false);
			}
			if (qi.basicGetItem()) {
				qi.basicGetItem().length = 0;
			}
			if (qi.basicGetSplitDefinition()) {
				qi.basicGetSplitDefinition().length = 0;
			}
		} else if ("Calculation" == ref.getObjectType()) {
			var calc = ref;
			qi = objectFactory.createQueryItem();
			MetricCommonUtils.setCommonQueryItemProp(qi, role, ref.getIdForExpression(), sentimentType, objectFactory);
			qi.setLabel(calc.getLabel());
			qi.setUsage(calc.getUsage());
			qi.setEditMode(null);
			qi.setAggregateMode(calc.getAggregateMode());
			if (UsageType.ATTRIBUTE == calc.getUsage()) {
				PropertySetter.set(qi, 194, RegularAggregateType.NONE, false);
			} else {
				PropertySetter.set(qi, 194, calc.getRegularAggregate(), false);
			}
			qi.setDatatype(calc.getDatatype());
			qi.setDatatypeCategory(calc.getDatatypeCategory());
			qi.setFormat(calc.getFormat());
			qi.setHighlevelDatatype(calc.getHighlevelDatatype());
			qi.setNullable(calc.isNullable());
			for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getList(calc.basicGetTaxonomy()), __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var taxObj = __exp_enFor0[__i_enFor0];
				var tax = taxObj;
				qi.addTaxonomy(tax.clone());
			}
			idGenerator.generateId(qi);
		}
		if (!qi) {
			return null;
		}
		return qi;
	}

	static processObjectList(objs, qs, idGenerator, objectFactory, folderLabel) {
		var folderItemType;
		var folder;
		if (folderLabel != null && !(objs.length==0)) {
			folderItemType = objectFactory.createItemType();
			folder = objectFactory.createItemTypeFolder();
			folder.setLabel(folderLabel);
			folderItemType.setFolder(folder);
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = objs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			var qi = MetricCommonUtils.createMetricQueryItem(idGenerator, obj, null, null, objectFactory);
			if (qi) {
				var itemType = new ItemType();
				itemType.setQueryItem(qi);
				if (folder) {
					folder.addItem(itemType);
				} else {
					qs.addItem(itemType);
				}
			}
		}
		if (folderItemType) {
			qs.addItem(folderItemType);
		}
	}

	static setMetricDefinitionAttr(qs, label, idGenerator) {
		qs.setLabel(label);
		qs.setInstanceType(InstanceType.COPY);
		qs.setClassifier(QsClassifierType.METRIC_DEFINITION);
		qs.setGenerateSQL(GenerateSQL.MINIMIZED);
		qs.setSelectListControl(SelectListControlType.USED_QUERY_ITEMS);
		idGenerator.generateId(qs);
	}

	static groupObjectsByQS(attrs) {
		var outputList = [];
		var qsIdToOutputIndex = {};
		for (var __i_enFor0 = 0, __exp_enFor0 = attrs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var attr = __exp_enFor0[__i_enFor0];
			var qs = QuerySubjectUtils.getParentQuerySubject(attr);
			if (!qs) {
				var group = [];
				group.push(attr);
				outputList.push(group);
			} else {
				if (qsIdToOutputIndex.hasOwnProperty(qs.getIdentifier())) {
					var index = qsIdToOutputIndex[qs.getIdentifier()];
					var group = outputList[index];
					group.push(attr);
				} else {
					var group = [];
					group.push(attr);
					var index = outputList.length;
					outputList.push(group);
					qsIdToOutputIndex[qs.getIdentifier()] = index;
				}
			}
		}
		var sortedOutputList = [];
		for (var __i_enFor1 = 0, __exp_enFor1 = outputList, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var output = __exp_enFor1[__i_enFor1];
			sortedOutputList.push(MoserObjectUtils.sortByLabel(output));
		}
		return sortedOutputList;
	}

	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/MetricCommonUtils.js